import { Image } from "antd";
import { IDriver } from "models/driver";

interface IProps {
  data?: IDriver | undefined;
}

export default function Images({ data }: IProps) {
  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full">
        <h4 className="text-lg font-medium">Licenses Detail</h4>
        <div className="w-full flex flex-wrap gap-6 mt-6">
          <div className="flex gap-y-2 flex-col">
            <p className="font-normal">Driving License</p>
            <Image
              height={200}
              src={data?.driving_license_image}
              width={200}
              className="rounded-md object-cover"
            />
          </div>
          <div className="flex gap-y-2 flex-col">
            <p className="font-normal">Insurance Subscription</p>
            <Image
              height={200}
              src={data?.insurance_subscription_image}
              width={200}
              className="rounded-md object-cover"
            />
          </div>
          {data?.employment_agreement_image && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Employment Agreement</p>
              <Image
                height={200}
                src={data?.employment_agreement_image}
                width={200}
                className="rounded-md object-cover"
              />
            </div>
          )}
          <div className="flex gap-y-2 flex-col">
            <p className="font-normal">Business Licenses</p>
            <div className="w-full flex flex-wrap gap-6">
              {data?.business_license_images.map((value, key) => (
                <Image
                  height={200}
                  src={value}
                  width={200}
                  className="rounded-md object-cover"
                  key={key}
                />
              ))}
            </div>
          </div>

          {data?.fleet.image && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Fleet Image</p>
              <Image
                height={200}
                src={data?.fleet.image}
                width={200}
                className="rounded-md object-cover"
              />
            </div>
          )}
          {data?.fleet.license_image && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Fleet License Image</p>
              <Image
                height={200}
                src={data?.fleet.license_image}
                width={200}
                className="rounded-md object-cover"
              />
            </div>
          )}
          {data?.driver_id_image && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Driver Id Image</p>
              <Image
                height={200}
                src={data?.driver_id_image}
                width={200}
                className="rounded-md object-cover"
              />
            </div>
          )}
          {data?.owner_id_image && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Owner Id Image</p>
              <Image
                height={200}
                src={data?.owner_id_image}
                width={200}
                className="rounded-md object-cover"
              />
            </div>
          )}
          {data?.maheber_support_image && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Maheber Support Image</p>
              <Image
                height={200}
                src={data?.maheber_support_image}
                width={200}
                className="rounded-md object-cover"
              />
            </div>
          )}
          {data?.bolo_image && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Bolo Image</p>
              <Image
                height={200}
                src={data?.bolo_image}
                width={200}
                className="rounded-md object-cover"
              />
            </div>
          )}
          {data?.other_images && (
            <div className="flex gap-y-2 flex-col">
              <p className="font-normal">Other Images</p>
              <div className="w-full flex flex-row flex-wrap gap-3">
                {data?.other_images
                  .filter((image) => image !== data.driving_license_image)
                  .filter((image) => image !== data.insurance_subscription_image)
                  .filter((image) => image !== data.employment_agreement_image)
                  .filter((image) => image !== data.driver_id_image)
                  .filter((image) => image !== data.owner_id_image)
                  .filter((image) => image !== data.maheber_support_image)
                  .filter((image) => image !== data.bolo_image)
                  .filter((image) => image !== data.fleet?.image)
                  .filter((image) => image !== data.fleet?.license_image)
                  .map((image, index) => (
                    <Image
                      height={200}
                      src={image}
                      width={200}
                      className="rounded-md object-cover"
                      key={index}
                    />
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
